import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const NotFound = () => {
    const navigate = useNavigate();
    return (
        <Container>
            <Row className="justify-content-center py-md-5 px-2">
                <Col xl={12} lg={12} md={12} sm={10}>
                    <div className="error-404-container p-4 py-4 rounded-3">
                        <Row>
                            <Col xl={4} lg={6} md={12} sm={12}>
                                <div className="error-404-image"></div>
                            </Col>
                            <Col xl={8} lg={6} md={12} sm={12}>
                                <h1 className="error-404-size text-secondary">404</h1>
                                <h2 className="h1 mb-4 text-secondary"> <FormattedMessage id='error_title'/></h2>
                                <p className="h5 mb-4 text-secondary fw-normal"> <FormattedMessage id='error_description'/></p>
                                <a href="/" onClick={() => navigate('/')} className="btn btn-outline-secondary btn-lg"> <FormattedMessage id='go_main_page'/></a>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default NotFound;
